import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Radio, Globe, User } from 'lucide-react';
export default function MobileMenu() {
  const { pathname } = useLocation();
  return <nav className="client-mobile-nav" aria-label="Main navigation">
    {[['/app', 'Dashboard', Home], ['/app/events', 'Streams', Radio], ['/app/destinations', 'Destinations', Globe], ['/app/account', 'Account', User]].map(([path, label, Icon]) => {
      const active = path === '/app' ? pathname === path : pathname.startsWith(path) || (path === '/app/events' && pathname.startsWith('/app/stream'));
      return <Link key={path} to={path} aria-current={active ? 'page' : undefined}><Icon size={21}/><span>{label}</span></Link>;
    })}
  </nav>;
}
